module.exports = __webpack_public_path__ + "img/image151.a87c86f9.png";